import {Component} from '@angular/core';

@Component({
   selector: 'app-test-lib',
   templateUrl: './test-lib.component.html',
   styleUrls: ['./test-lib.component.css']
})
export class TestLibComponent {

   constructor() {
      // This is intentional.
   }
}
